(function () {

  const SAMPLE_SUFFIX = '-s';
  const MAX_TITLE_LENGTH = 42;

  function truncate(text, max) {
    if (!text) return '';
    return text.length > max ? text.slice(0, max - 1) + '…' : text;
  }

  function isSampleSku(sku) {
    return typeof sku === 'string' && sku.endsWith(SAMPLE_SUFFIX);
  }

  async function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
  }

  function lock(wrapper, label) {
    const btn = wrapper.querySelector('button');
    const text = wrapper.querySelector('.sample-atc__text');
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    text.textContent = label;
  }

  async function sampleInCart(sku) {
    const cart = await getCart();
    return cart.items.some(item => item.sku === sku);
  }

  async function addSample(wrapper) {
    const variantId = Number(wrapper.dataset.variantId);
    const sku = wrapper.dataset.sampleSku;
    const rawTitle =
      wrapper.dataset.productTitle ||
      document.querySelector('h1')?.textContent?.trim() ||
      'Item';

    const title = truncate(rawTitle, MAX_TITLE_LENGTH);

    if (await sampleInCart(sku)) {
      lock(wrapper, wrapper.dataset.labelLocked);
      return;
    }

    wrapper.querySelector('.sample-atc__text').textContent = 'Adding…';

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    });

    if (!res.ok) return;

    // 🔔 Toast notification
    document.dispatchEvent(
      new CustomEvent('cart:toast', {
        detail: {
          message: `${title} added to your cart`
        }
      })
    );

    lock(wrapper, wrapper.dataset.labelLocked);
  }

  async function syncAll() {
    const cart = await getCart();
    const sampleSkus = cart.items
      .filter(i => isSampleSku(i.sku))
      .map(i => i.sku);

    document.querySelectorAll('[data-sample-atc]').forEach(wrapper => {
      if (sampleSkus.includes(wrapper.dataset.sampleSku)) {
        lock(wrapper, wrapper.dataset.labelLocked);
      }
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-sample-atc] button');
    if (!btn) return;

    e.preventDefault();
    addSample(btn.closest('[data-sample-atc]'));
  });

  // Covers reload, back button, BFCache, incognito
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('pageshow', syncAll);

})();